"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _materialSymbols = require("@design/icons/material-symbols");
var _spinner = require("@design/ui/spinner");
var _tools = require("@common/constants/tools");
var _elapsed = require("@common/components/chat/elapsed");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Bar = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  margin: 0;\n  border: none;\n  border-top: 1px solid #e9ecef;\n  background: var(--background-surface);\n  cursor: pointer;\n  text-align: left;\n  &:hover {\n    background: var(--background-subtle);\n  }\n"])));
var StatusSpinner = (0, _styledComponents.default)(_spinner.Spinner)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  color: var(--muted-foreground);\n"])));
var Title = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--foreground-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 45%;\n"])));
var Meta = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 0;\n  font-size: 12px;\n  color: var(--muted-foreground);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var Elapsed = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #6b7280;\n  font-variant-numeric: tabular-nums;\n"])));
function LiveReviewStatusBar(_ref) {
  var playbookName = _ref.playbookName,
    status = _ref.status,
    checkedRules = _ref.checkedRules,
    totalRules = _ref.totalRules,
    startedAtMs = _ref.startedAtMs,
    onExpand = _ref.onExpand,
    onDismiss = _ref.onDismiss;
  var isRunning = status === "running";
  var now = (0, _elapsed.useLiveNow)(isRunning);
  var elapsed = (0, _elapsed.formatElapsed)(now - startedAtMs);
  var progressLabel = isRunning ? totalRules === 0 ? "Analyzing rules…" : "".concat(checkedRules, " / ").concat(totalRules, " rules checked") : status === "completed" ? "Review complete \xB7 ".concat(checkedRules, " / ").concat(totalRules, " rules checked \u2014 view results") : "Review finished with errors — view results";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Bar, {
    type: "button",
    onClick: onExpand,
    "aria-label": isRunning ? "".concat(playbookName, ": ").concat(progressLabel, ", ").concat(elapsed, " elapsed. Show details.") : "".concat(playbookName, ": ").concat(progressLabel, "."),
    "data-sentry-element": "Bar",
    "data-sentry-component": "LiveReviewStatusBar",
    "data-sentry-source-file": "LiveReviewStatusBar.tsx",
    children: [isRunning ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StatusSpinner, {
      className: "size-3.5",
      "aria-hidden": "true"
    }) : status === "completed" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckCircleIcon, {
      width: 14,
      height: 14,
      color: "#15803d",
      style: {
        flexShrink: 0
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
      width: 14,
      height: 14,
      color: "#b45309",
      style: {
        flexShrink: 0
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Title, {
      "data-sentry-element": "Title",
      "data-sentry-source-file": "LiveReviewStatusBar.tsx",
      children: playbookName
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Meta, {
      "data-sentry-element": "Meta",
      "data-sentry-source-file": "LiveReviewStatusBar.tsx",
      children: [(0, _tools.getToolDisplayName)("live_review"), " \xB7 ", progressLabel]
    }), isRunning && /*#__PURE__*/(0, _jsxRuntime.jsx)(Elapsed, {
      children: elapsed
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
      width: 14,
      height: 14,
      color: "#6b7280",
      style: {
        flexShrink: 0
      },
      "data-sentry-element": "ChevronRightIcon",
      "data-sentry-source-file": "LiveReviewStatusBar.tsx"
    }), !isRunning && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
      width: 14,
      height: 14,
      color: "#6b7280",
      "aria-label": "Dismiss review status",
      role: "button",
      style: {
        flexShrink: 0
      },
      onClick: function onClick(event) {
        event.stopPropagation();
        onDismiss();
      }
    })]
  });
}
var _default = exports.default = LiveReviewStatusBar;